import { extend } from "lodash";
import { genArray } from "@/arrays/genArray";

interface ArrayToPrefixedDictConfig<T> {
  minLength?: number;
  fallback?: T;
}

export function arrayToPrefixedDict<PrefixType extends string, T>(
  arr: T[],
  prefix: PrefixType,
  { minLength, fallback }: ArrayToPrefixedDictConfig<T> = {},
): Record<`${PrefixType}${number}`, T> {
  return extend(
    arr,
    genArray(() => fallback, (minLength ?? 0) - arr.length),
  ).reduce(
    (acc, item, i) => {
      acc[`${prefix}${i + 1}`] = item;
      return acc;
    },
    {} as Record<`${PrefixType}${number}`, T>,
  );
}

export default arrayToPrefixedDict;
